<div class="associated-maps">
  <ul class="list-inline d-inline-block m-0">
    <li class="li-title list-inline-item p-3" (click)="openMapsModal()">ASSOCIATED MAPS</li>
    <li class="list-inline-item p-3" *ngFor="let map of data.textContent.maps"><i class="fa fa-key" *ngIf="map.isKey"></i>{{map.name}}</li>
  </ul>
</div>
<rms-text-content-associated-map-modal [data]="data"></rms-text-content-associated-map-modal>
